module.exports = __webpack_public_path__ + "static/media/c2d.51f55ab7.webp";